var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { mockData as calendars } from '@web/lib/demo/data/calendarEvents';
import { mockData as chatEvents } from '@web/lib/demo/data/chatEvents';
import { mockData as documentEvents } from '@web/lib/demo/data/documentEvents';
import { matchesDemoActivityLabelFilter } from '@web/lib/demo/data/labelMatching';
import { mockData as meetingsEvents } from '@web/lib/demo/data/meetingEvents';
import { mockData as users } from '@web/lib/demo/data/users';
import { dateToTimestamp, demoDataPagination, filterData, getUsers } from '@web/lib/demo/utils';
import { ApplicationEnum, SortOrderEnum } from '@workalizer/shared';
export var events = function (input) {
    var _a, _b;
    var filteredUserIds = getUsers({
        orgUnitId: input.orgUnitId,
        userId: input.userId
    }).map(function (user) { return user.id; });
    var userIdFilter = {
        key: 'userId',
        value: filteredUserIds,
        operator: 'in',
        isSkip: !input.userId && !input.orgUnitId
    };
    var dataDocumentEvents = filterData(documentEvents, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        userIdFilter
    ]).map(function (event) {
        var user = users.find(function (user) { return user.id === event.userId; });
        return {
            id: event.id,
            date: event.date,
            action: event.action,
            title: event.document.title,
            value: 1,
            applicationName: ApplicationEnum.DRIVE,
            user: {
                id: (user === null || user === void 0 ? void 0 : user.id) || 0,
                email: (user === null || user === void 0 ? void 0 : user.email) || '',
                name: (user === null || user === void 0 ? void 0 : user.name) || '',
                avatar: (user === null || user === void 0 ? void 0 : user.avatar) || ''
            },
            meetingsEvent: null,
            documentEvent: {
                id: event.document.id,
                title: event.document.title,
                slugId: event.document.slugId,
                type: event.document.type,
                document: {
                    id: event.document.id,
                    title: event.document.title,
                    slugId: event.document.slugId,
                    type: event.document.type
                }
            },
            chatEvent: null
        };
    });
    var dataChatEvents = filterData(chatEvents, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        userIdFilter
    ]).map(function (event) {
        var user = users.find(function (user) { return user.id === event.userId; });
        return {
            id: event.id,
            date: event.date,
            action: event.action,
            title: event.room.title,
            value: 1,
            applicationName: ApplicationEnum.CHAT,
            user: {
                id: (user === null || user === void 0 ? void 0 : user.id) || 0,
                email: (user === null || user === void 0 ? void 0 : user.email) || '',
                name: (user === null || user === void 0 ? void 0 : user.name) || '',
                avatar: (user === null || user === void 0 ? void 0 : user.avatar) || ''
            },
            meetingsEvent: null,
            documentEvent: null,
            chatEvent: {
                subUser: null,
                room: {
                    id: event.room.id,
                    slugId: event.room.slugId,
                    title: event.room.title,
                    type: event.room.type
                }
            }
        };
    });
    var dataMeetingsEvents = filterData(meetingsEvents, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        userIdFilter
    ]).map(function (event) {
        var _a;
        var user = users.find(function (user) { return user.id === event.userId; });
        var calendar = (_a = calendars.find(function (calendar) { return calendar.id === event.meeting.calendarId; })) === null || _a === void 0 ? void 0 : _a.calendar;
        return {
            id: event.id,
            date: event.date,
            action: event.action,
            title: (calendar === null || calendar === void 0 ? void 0 : calendar.title) || '',
            value: 1,
            applicationName: ApplicationEnum.MEET,
            user: {
                id: (user === null || user === void 0 ? void 0 : user.id) || 0,
                email: (user === null || user === void 0 ? void 0 : user.email) || '',
                name: (user === null || user === void 0 ? void 0 : user.name) || '',
                avatar: (user === null || user === void 0 ? void 0 : user.avatar) || ''
            },
            meetingsEvent: {
                meeting: {
                    meetingGuests: event.meeting.meetingGuests.map(function (guest) {
                        var _a, _b, _c;
                        return ({
                            user: {
                                id: guest.userId,
                                email: ((_a = users.find(function (user) { return user.id === guest.userId; })) === null || _a === void 0 ? void 0 : _a.email) || '',
                                name: ((_b = users.find(function (user) { return user.id === guest.userId; })) === null || _b === void 0 ? void 0 : _b.name) || '',
                                avatar: ((_c = users.find(function (user) { return user.id === guest.userId; })) === null || _c === void 0 ? void 0 : _c.avatar) || ''
                            }
                        });
                    }),
                    calendar: {
                        id: (calendar === null || calendar === void 0 ? void 0 : calendar.id) || 0,
                        slugId: (calendar === null || calendar === void 0 ? void 0 : calendar.slugId) || '',
                        title: (calendar === null || calendar === void 0 ? void 0 : calendar.title) || ''
                    }
                }
            },
            documentEvent: null,
            chatEvent: null
        };
    });
    var all = __spreadArray(__spreadArray(__spreadArray([], dataDocumentEvents, true), dataChatEvents, true), dataMeetingsEvents, true);
    var filteredByApp = filterData(all, [
        {
            key: 'applicationName',
            value: (_a = input.applicationName) !== null && _a !== void 0 ? _a : ApplicationEnum.DRIVE,
            operator: 'eq',
            isSkip: !input.applicationName
        }
    ]);
    var filtered = input.activityLabelId
        ? filteredByApp.filter(function (event) {
            return matchesDemoActivityLabelFilter(event.title, input.activityLabelId);
        })
        : filteredByApp;
    var orderBy = (_b = input.orderBy) !== null && _b !== void 0 ? _b : SortOrderEnum.DESC;
    var sorted = filtered.sort(function (a, b) {
        var diff = dateToTimestamp(a.date) - dateToTimestamp(b.date);
        return orderBy === SortOrderEnum.DESC ? -diff : diff;
    });
    return demoDataPagination(sorted, {
        limit: input.limit,
        offset: input.offset
    });
};
